import userProfile from "services/user.profile";
import {
  CHANGE_TIMEZONE,
  PROFILE_INFO,
  PROFILE_PHOTO,
  PROFILE_TIMEZONE,
  SET_MESSAGE,
} from "./types";

export const profileInfo = (dispatch) => {
  return userProfile.getProfileInfo().then(
    ({ data }) => {
      dispatch({
        type: PROFILE_INFO,
        payload: data,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const profilePhoto = (dispatch) => {
  return userProfile.getProfilePhoto().then(
    ({ data }) => {
      dispatch({
        type: PROFILE_PHOTO,
        payload: data?.photo,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const profileTimezone = (dispatch) => {
  return userProfile.getCurrentTimezone().then(
    ({ data }) => {
      dispatch({
        type: PROFILE_TIMEZONE,
        payload: data.timezone,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};

export const changeTimezone = (timeZoneValue) => (dispatch) => {
  return userProfile.changeTimezone(timeZoneValue).then(
    ({ data }) => {
      dispatch({
        type: CHANGE_TIMEZONE,
        payload: data,
      });

      return Promise.resolve();
    },
    (error) => {
      dispatch({
        type: SET_MESSAGE,
        payload: error,
      });

      return Promise.reject(error);
    }
  );
};
